import { render, staticRenderFns } from "./citizenship_minor.vue?vue&type=template&id=795e91e0&"
import script from "./citizenship_minor.vue?vue&type=script&lang=js&"
export * from "./citizenship_minor.vue?vue&type=script&lang=js&"
import style0 from "./citizenship_minor.vue?vue&type=style&index=0&id=795e91e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports